import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Cookie, X } from 'lucide-react';

export const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [showPreferences, setShowPreferences] = useState(false);
  const [preferences, setPreferences] = useState({
    necessary: true, // Toujours actif
    analytics: false,
    marketing: false
  });

  useEffect(() => {
    // Vérifier si l'utilisateur a déjà donné son consentement
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      // Attendre 1 seconde avant d'afficher le bandeau
      setTimeout(() => {
        setShowBanner(true);
      }, 1000);
    }
  }, []);

  const handleAcceptAll = () => {
    const consentData = {
      necessary: true,
      analytics: true,
      marketing: true,
      timestamp: new Date().toISOString()
    };
    localStorage.setItem('cookieConsent', JSON.stringify(consentData));
    setShowBanner(false);
  };

  const handleRejectAll = () => {
    const consentData = {
      necessary: true,
      analytics: false,
      marketing: false,
      timestamp: new Date().toISOString()
    };
    localStorage.setItem('cookieConsent', JSON.stringify(consentData));
    setShowBanner(false);
  };

  const handleSavePreferences = () => {
    const consentData = {
      ...preferences,
      timestamp: new Date().toISOString()
    };
    localStorage.setItem('cookieConsent', JSON.stringify(consentData));
    setShowBanner(false);
    setShowPreferences(false);
  };

  const handlePreferenceChange = (key) => {
    if (key === 'necessary') return; // Les cookies nécessaires ne peuvent pas être désactivés
    setPreferences(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  if (!showBanner) return null;

  return (
    <>
      <div className="cookie-overlay" onClick={() => setShowBanner(false)}></div>
      
      <div className="cookie-banner">
        <button 
          className="cookie-close"
          onClick={() => setShowBanner(false)}
          aria-label="Fermer"
        >
          <X size={24} />
        </button>

        {!showPreferences ? (
          <div className="cookie-content">
            <div className="cookie-header">
              <Cookie size={32} className="cookie-icon" />
              <h3 className="heading-2">Respect de votre vie privée</h3>
            </div>
            
            <p className="body-medium">
              Nous utilisons des cookies pour améliorer votre expérience sur notre site, 
              analyser le trafic et personnaliser le contenu. Vous pouvez accepter tous les cookies, 
              les refuser ou personnaliser vos préférences.
            </p>

            <div className="cookie-actions">
              <button 
                className="btn-primary"
                onClick={handleAcceptAll}
              >
                Tout accepter
              </button>
              <button 
                className="btn-secondary"
                onClick={handleRejectAll}
              >
                Tout refuser
              </button>
              <button 
                className="btn-link"
                onClick={() => setShowPreferences(true)}
              >
                Personnaliser
              </button>
            </div>

            <div className="cookie-footer">
              <Link to="/confidentialite" onClick={() => setShowBanner(false)}>
                Politique de confidentialité
              </Link>
            </div>
          </div>
        ) : (
          <div className="cookie-preferences">
            <div className="cookie-header">
              <Cookie size={32} className="cookie-icon" />
              <h3 className="heading-2">Gérer mes préférences</h3>
            </div>

            <div className="cookie-options">
              <div className="cookie-option">
                <div className="cookie-option-header">
                  <label className="cookie-label">
                    <input
                      type="checkbox"
                      checked={preferences.necessary}
                      disabled
                    />
                    <span className="cookie-option-title">Cookies nécessaires</span>
                  </label>
                  <span className="cookie-badge required">Obligatoire</span>
                </div>
                <p className="cookie-option-description">
                  Ces cookies sont essentiels au fonctionnement du site et ne peuvent pas être désactivés. 
                  Ils permettent la navigation et l'utilisation des fonctionnalités de base.
                </p>
              </div>

              <div className="cookie-option">
                <div className="cookie-option-header">
                  <label className="cookie-label">
                    <input
                      type="checkbox"
                      checked={preferences.analytics}
                      onChange={() => handlePreferenceChange('analytics')}
                    />
                    <span className="cookie-option-title">Cookies analytiques</span>
                  </label>
                </div>
                <p className="cookie-option-description">
                  Ces cookies nous permettent de mesurer l'audience et d'améliorer notre site 
                  en analysant la manière dont les visiteurs l'utilisent.
                </p>
              </div>

              <div className="cookie-option">
                <div className="cookie-option-header">
                  <label className="cookie-label">
                    <input
                      type="checkbox"
                      checked={preferences.marketing}
                      onChange={() => handlePreferenceChange('marketing')}
                    />
                    <span className="cookie-option-title">Cookies marketing</span>
                  </label>
                </div>
                <p className="cookie-option-description">
                  Ces cookies sont utilisés pour vous proposer des publicités et du contenu 
                  personnalisés en fonction de vos centres d'intérêt.
                </p>
              </div>
            </div>

            <div className="cookie-actions">
              <button 
                className="btn-primary"
                onClick={handleSavePreferences}
              >
                Enregistrer mes préférences
              </button>
              <button 
                className="btn-secondary"
                onClick={() => setShowPreferences(false)}
              >
                Retour
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
